import { useState } from "react";
import api from "../../api/api";
import "./ProductivityModal.css";

function ProductivityModal({ onClose, streak, onSuccess }) {
  const [activity, setActivity] = useState("");
  const [learning, setLearning] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!activity.trim() || !learning.trim()) return;

    try {
      setLoading(true);

      await api.post("/productivity/mark", {
        activity,
        learning,
      });

      onSuccess();
    } catch (err) {
      alert(
        err.response?.data?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2>🔥 Mark Today’s Productivity</h2>

        <div className="modal-streak-hero">
          <div className="hero-old">
            🔥 {streak}
          </div>

          <div className="hero-arrow">→</div>

          <div className="hero-new">
            🔥 {streak + 1}
          </div>

          <p className="hero-text">
            Complete today to grow your streak.
          </p>
        </div>

        <label>What productive activity did you do today?</label>
        <input
          type="text"
          value={activity}
          onChange={(e) => setActivity(e.target.value)}
          placeholder="Solved 3 RTL problems..."
        />

        <label>What did you learn today?</label>
        <textarea
          rows="4"
          value={learning}
          onChange={(e) => setLearning(e.target.value)}
          placeholder="Understood AXI handshake deeper..."
        />

        <div className="discipline-box">
          <p className="discipline-main">
            😊 Be honest with yourself. Log only real work.
            The streak is for your discipline.
          </p>

          <p className="discipline-sub">
            ⚠️ For coding, projects, or practical work only.
            📺 Watching course videos is the primary way to earn streak.
          </p>
        </div>

        <div className="modal-actions">
          <button
            className="cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="save-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save & Earn Streak"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductivityModal;